module.exports={Earlier:"PLUS TÔT",New:"NOUVEAU",NoAnnouncements:"Vous n’avez aucune annonce"};